import { IconButtonVariant } from "@inputs/button/IconButtonVariant";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress, Stack } from "@mui/material";

export interface IPaperCandidateChallengeEditButtonsProps {
  disabled?: boolean;
  loading?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const PaperCandidateChallengeEditButtons = ({
  disabled,
  loading,
  onCancel,
  onSubmit,
}: IPaperCandidateChallengeEditButtonsProps) => (
  <Stack sx={{ flexDirection: "row", alignItems: "center", justifyContent: "end", gap: 1 }}>
    <IconButtonVariant type="button" variant="elevated" size="large" onClick={onCancel} disabled={disabled}>
      <CloseIcon color="primary" />
    </IconButtonVariant>
    <IconButtonVariant type="button" variant="elevated" size="large" onClick={onSubmit} disabled={disabled}>
      {loading ? <CircularProgress color="primary" size={20} /> : <CheckIcon color="success" />}
    </IconButtonVariant>
  </Stack>
);
